import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './login.html'
})
export class Login {

  username = '';

  password = '';

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  login()
  {
    this.http.post<any>(
      'https://lazzaro-api1.onrender.com/api/auth/login',
      {
        username: this.username,
        password: this.password
      })
      .subscribe({
        next: (res) =>
        {
          localStorage.setItem(
            'token',
            res.token);

          this.router.navigate(['/admin']);
        },
        error: () =>
        {
          alert('Wrong credentials');
        }
      });
  }
}